<template>
  <div class="category-list-box" v-if="pageData.items && pageData.items.length > 0">
    <el-table :data="pageData.items" border style="width: 100%">
      <el-table-column align="center" prop="id" label="ID" width="100" />
      <el-table-column prop="name" label="名称" />
      <el-table-column header-align="center" label="操作" width="200">
        <template slot-scope="scope">
          <span class="action" @click="showEdit(scope.row)">编辑</span>
          <span class="action" @click="remove(scope.row.id)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="pageData.totalPage">
      <el-pagination background layout="total, prev, pager, next" :current-page="pageData.page" :page-size="pageData.pageSize" :total="pageData.amount" @current-change="handlePageChange" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaListComponent',
  props: {
    pageData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    handleRemove: {}
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    showEdit (data) {
      this.$emit('onItemEdit', data)
    },
    handlePageChange (val) {
      this.$emit('onPageChanged', val)
    },
    remove (id) {
      let that = this
      this.$confirm('删除当前内容？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.handleRemove && that.handleRemove({id: id})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="less">

.pagination {
  margin-top: 20px;
  text-align: center;
}

.icon{
  width:36px;
  height:36px;
}

.action {
  color: #3a8ee6;
  padding: 0 5px;

  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/area/AreaListComponent.vue